import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { Link } from 'components/Link/Link';
import { SlugTitle } from 'data/SingleArticle/types';
import { useTrackEvent } from 'tracking/useTrackEvent';

type Props = {
  items: SlugTitle[];
  title: string;
};

export const Pills = ({ items, title }: Props) => {
  const trackEvent = useTrackEvent();

  return (
    <Outer data-testid="pills">
      <Heading>{title}</Heading>
      <ContentWrapper>
        {items.map((item) => (
          <PillWrapper key={item.slug}>
            <Link
              color={'white'}
              href={item.slug}
              onClick={(event) =>
                trackEvent('linkClicked', {
                  linkText: item.title,
                  href: item.slug,
                  path: window.location.pathname,
                  posYFromTop: event.clientY,
                })
              }
            >
              <Content>{item.title}</Content>
            </Link>
          </PillWrapper>
        ))}
      </ContentWrapper>
    </Outer>
  );
};

const Outer = styled.div`
  max-width: 600px;
`;

const Heading = styled.strong`
  color: ${Colors.grey900};
  display: inline;
  float: left;
  font-size: 14px;
  font-weight: bold;
  padding-top: 15px;
  margin-right: 10px;
  text-transform: uppercase;
`;

const ContentWrapper = styled.ul`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`;
const PillWrapper = styled.div`
  margin: 10px 10px 0 0;
`;

const Content = styled.li`
  border: 1px solid ${Colors.grey900};
  border-radius: 10px;
  font-size: 14px;
  padding: 4px 15px;
  &:hover {
    background-color: ${Colors.black};
  }
`;
